module.exports = __webpack_public_path__ + "img/qrcodeBox.e992948a.png";